import Vue from 'vue'
import Vuex from 'vuex'
import store from '@/store/store'
import Router from 'vue-router'
import CoreLayout from '@/layouts/CoreLayout'
import Login from '@/components/RouteComponents/Auth/Login'
import ForgotPassword from '@/components/RouteComponents/Auth/ForgotPassword'
import ChangePassword from '@/components/RouteComponents/Auth/ChangePassword'
import Forbidden from '@/components/RouteComponents/Auth/403'
import setupPassword from '@/components/RouteComponents/Auth/setupPassword'
import Ledger from '@/components/RouteComponents/Ledger/Ledger'
import BatchListView from '@/components/RouteComponents/Batches/Batches'
import JeIndexView from '@/components/RouteComponents/Jes/Index'
import JeListView from '@/components/RouteComponents/Jes/Jes'
import JeCreateView from '@/components/RouteComponents/Jes/New'
import JeEditView from '@/components/RouteComponents/Jes/Edit'
import ApIndexView from '@/components/RouteComponents/Aps/Index'
import ApListView from '@/components/RouteComponents/Aps/Aps'
import ApCreateView from '@/components/RouteComponents/Aps/New'
import ApEditView from '@/components/RouteComponents/Aps/Edit'
import ArIndexView from '@/components/RouteComponents/Ars/Index'
import EmployeeEarningsReport from '@/components/Reports/EmployeeEarningsReport'
import ArListView from '@/components/RouteComponents/Ars/Ars'
import ArCreateView from '@/components/RouteComponents/Ars/New'
import ArEditView from '@/components/RouteComponents/Ars/Edit'
import BpIndexView from '@/components/RouteComponents/Bps/Index'
import BpListView from '@/components/RouteComponents/Bps/Bps'
import BpCreateView from '@/components/RouteComponents/Bps/New'
import BpEditView from '@/components/RouteComponents/Bps/Edit'
import PpIndexView from '@/components/RouteComponents/Pps/Index'
import PpListView from '@/components/RouteComponents/Pps/Pps'
import PpCreateView from '@/components/RouteComponents/Pps/New'
import PpEditView from '@/components/RouteComponents/Pps/Edit'
import PcIndexView from '@/components/RouteComponents/PettyCash/Index'
import PcListView from '@/components/RouteComponents/PettyCash/PettyCash'
import PcCreateView from '@/components/RouteComponents/PettyCash/New'
import PcEditView from '@/components/RouteComponents/PettyCash/Edit'
import PoIndexView from '@/components/RouteComponents/Pos/Index'
import PoListView from '@/components/RouteComponents/Pos/Pos'
import PoCreateView from '@/components/RouteComponents/Pos/New'
import PoEditView from '@/components/RouteComponents/Pos/Edit'
import PrIndexView from '@/components/RouteComponents/Prs/Index'
import PrListView from '@/components/RouteComponents/Prs/Prs'
import PrCreateView from '@/components/RouteComponents/Prs/New'
import PrEditView from '@/components/RouteComponents/Prs/Edit'
import Checks from '@/components/RouteComponents/Checks/Checks'
import AccountListView from '@/components/RouteComponents/Accounts/Accounts'
import AccountGroup from '@/components/RouteComponents/AccountGroup/AccountGroup'
import VendorListView from '@/components/RouteComponents/Vendors/Vendors'
import VendorImport from '@/components/SigmaClientNew/VendorImport'
// import AddressListView from '@/components/RouteComponents/Addresses/Addresses'
import States from '@/components/RouteComponents/States/States'
import Countries from '@/components/RouteComponents/Countries/Countries'
import SetListView from '@/components/RouteComponents/Sets/Sets'
import UserView from '@/components/RouteComponents/Users/Users'
import SeriesListView from '@/components/RouteComponents/Series/Series'
import LocationListView from '@/components/RouteComponents/Locations/Locations'
import InsuranceListView from '@/components/RouteComponents/Insurances/Insurances'
import Freefields from '@/components/RouteComponents/Freefields/Freefields'
import TaxcodeListView from '@/components/RouteComponents/Taxcodes/Taxcodes'
import BudgetListView from '@/components/RouteComponents/Budgets/Budgets'
import AssetListView from '@/components/RouteComponents/Assets/Assets'
import BankListView from '@/components/RouteComponents/Banks/Banks'
import CompanyListView from '@/components/RouteComponents/Companies/Companies'
import CurrencyListView from '@/components/RouteComponents/Currencies/Currencies'
import ProductionListView from '@/components/RouteComponents/Productions/Productions'
import SalesrepListView from '@/components/RouteComponents/Salesreps/Salesreps'
import CustomerListView from '@/components/RouteComponents/Customers/Customers'
import BillabletypeListView from '@/components/RouteComponents/Billabletypes/Billabletypes'
import BillableitemListView from '@/components/RouteComponents/Billableitems/Billableitems'
import MarkupListView from '@/components/RouteComponents/Markups/Markups'
import ProgramsIndexView from '@/components/Programs/Index'
import TransactionPostingView from '@/components/Programs/TransactionPosting'
import CheckProcessingView from '@/components/Programs/CheckProcessing/CheckProcessing'
// import CostReporterView from '@/components/Programs/CostReporter/CostReporter'
import CostReporterBetaView from '@/components/Programs/CostReporterBeta'
import PeriodManagerView from '@/components/Programs/PeriodManager'
import BankRecIndexView from '@/components/Programs/BankRecon/Index'
import BankRecListView from '@/components/Programs/BankRecon/BankRecs'
import BankRecCreateView from '@/components/Programs/BankRecon/New'
import BankRecReadView from '@/components/Programs/BankRecon/View'
import CheckRegister from '@/components/Reports/CheckRegister'
import TrialBalanceCustom from '@/components/Reports/TrialBalanceCustom'
import GlReportCustom from '@/components/Reports/GlReportCustom'
import PayrollTransactionCustom from '@/components/Payroll/PayrollTransactionCustom'
import PayrollClientExport from '@/components/Payroll/PayrollClientExport'
import PayrollStatus from '@/components/Payroll/PayrollStatus'
import PayrollCheckRegister from '@/components/Payroll/PayrollCheckRegister'
import PayrollTaxLiability from '@/components/Payroll/PayrollTaxLiability'
import PayrollUnionExport from '@/components/Payroll/PayrollUnionExport'
import PayrollDdExport from '@/components/Payroll/PayrollDdExport'
import VendorReportCustom from '@/components/Reports/VendorReportCustom'
import VendorListCustom from '@/components/Reports/VendorListCustom'
import AccountListCustom from '@/components/Reports/AccountListCustom'
import AssetReportCustom from '@/components/Reports/AssetReportCustom'
import TaxReportCustom from '@/components/Reports/TaxReportCustom'
import TaxReportCustom2020 from '@/components/Reports/TaxReportCustom2020'
import TaxReportCustom2021 from '@/components/Reports/TaxReportCustom2021'
import TaxReportCustom2022 from '@/components/Reports/TaxReportCustom2022'
import TaxReportCustom2023 from '@/components/Reports/TaxReportCustom2023'
import TaxReportCustom2024 from '@/components/Reports/TaxReportCustom2024'
import TaxReportCustom2025 from '@/components/Reports/TaxReportCustom2025'
import PoReportCustom from '@/components/Reports/PoReportCustom'
import PoReportCustom1 from '@/components/Reports/PoReportCustom1'
import BankRecReportCustom from '@/components/Reports/BankRecReportCustom'
import PositivePay from '@/components/Programs/PositivePay'
// import NachaExport from '@/components/Programs/NachaExport'
import SignatureCapture from '@/components/Programs/CheckProcessing/SignatureCapture'
import BudgetImportView from '@/components/RouteComponents/Budgets/BudgetImport'
import PaymentProcessing from '@/components/Programs/PaymentProcessing/PaymentProcessing'
import HomeView from '@/components/Home'
import SearchResults from '@/components/RouteComponents/SearchResults'
import Payments from '@/components/RouteComponents/Payments/Payments'
import APAgingReport from '@/components/Reports/APAgingReport'
import DepartmentsListView from '@/components/RouteComponents/Departments/Departments'
import RolesListView from '@/components/RouteComponents/Roles/Roles'
import OpenItemsByAccountReport from '@/components/Reports/OpenItemsByAccountReport'
import OpenItemsByVendorReport from '@/components/Reports/OpenItemsByVendorReport'
import ProscanIndexView from '@/components/RouteComponents/Proscan/Index'
import ProscanListView from '@/components/RouteComponents/Proscan/Proscan'

Vue.use(Router)
Vue.use(Vuex)

const routes = [
  {
    path: '/',
    name: 'RootRoute',
    redirect: { name: 'Home' },
    component: CoreLayout,
    beforeEnter: async (to, from, next) => {
      let response
      try {
        if (to.query.hasOwnProperty('instances') && Object.keys(to.query.instances).length) {
          response = await store.dispatch('fetchInstances', to.query.instances)
        } else {
          response = await store.dispatch('fetchInstances')
        }
        if (response && response.status === 200) {
          next()
        } else {
          throw new Error(response)
        }
      } catch (e) {
        console.log(e.statusText ? e.statusText : 'Error fetching instances')
      }
    },
    children: [
      {
        path: 'login',
        name: 'Login',
        component: Login
      },
      {
        path: 'forgot_password',
        name: 'Forgot Password',
        component: ForgotPassword
      },
      {
        path: 'change_password',
        name: 'Change Password',
        component: ChangePassword,
        meta: { requiresAuth: true }
      },
      {
        path: '403',
        name: '403',
        component: Forbidden,
        meta: { requiresAuth: true }
      },
      {
        path: 'setup',
        name: 'Setup New User',
        component: setupPassword
      },
      {
        path: 'ledger',
        name: 'Ledger',
        component: Ledger,
        meta: { requiresAuth: true }
      },
      {
        path: 'batches',
        name: 'Batches',
        component: BatchListView,
        meta: { requiresAuth: true, permissionsRequired: ['entry.view_batch'] }
      },
      {
        path: 'jes',
        component: JeIndexView,
        meta: { requiresAuth: true, permissionsRequired: ['entry.view_journalentry'] },
        beforeEnter: async (to, from, next) => {
          try {
            const { getCurrentPeriod } = store.getters
            if (!(getCurrentPeriod && Object.keys(getCurrentPeriod).length)) {
              await store.dispatch('fetchPeriodsWithQuery', { active: 'True' })
            }
          } catch (e) {
            console.log(e)
          } finally {
            next()
          }
        },
        children: [
          {
            path: '',
            name: 'JEs',
            component: JeListView,
            meta: {
              requiresAuth: true,
              prettyName: 'Journal Entries',
              permissionsRequired: ['entry.view_journalentry']
            }
          },
          {
            path: 'new',
            name: 'NewJe',
            component: JeCreateView,
            meta: {
              requiresAuth: true,
              prettyName: 'New JE',
              permissionsRequired: ['entry.view_journalentry', 'entry.add_journalentry']
            }
          },
          {
            path: ':id',
            name: 'EditJe',
            component: JeEditView,
            meta: {
              requiresAuth: true,
              prettyName: 'Edit JE',
              permissionsRequired: ['entry.view_journalentry']
            }
          }
        ]
      },
      {
        path: 'proscan',
        component: ProscanIndexView,
        meta: { requiresAuth: true, permissionsRequired: ['entry.view_accountspayable', 'entry.view_purchaseorder', 'system.view_vendor'] },
        children: [
          {
            path: '',
            name: 'Proscan',
            component: ProscanListView,
            meta: {
              requiresAuth: true,
              prettyName: 'Proscan',
              permissionsRequired: ['entry.view_accountspayable', 'entry.view_purchaseorder', 'system.view_vendor']
            }
          }
        ]
      },
      {
        path: 'aps',
        component: ApIndexView,
        meta: { requiresAuth: true, permissionsRequired: ['entry.view_accountspayable'] },
        children: [
          {
            path: '',
            name: 'APs',
            component: ApListView,
            meta: {
              requiresAuth: true,
              prettyName: 'Accounts Payable',
              permissionsRequired: ['entry.view_accountspayable']
            }
          },
          {
            path: 'new',
            name: 'NewAp',
            component: ApCreateView,
            meta: {
              requiresAuth: true,
              prettyName: 'New AP',
              permissionsRequired: ['entry.view_accountspayable', 'entry.add_accountspayable']
            }
          },
          {
            path: ':id',
            name: 'EditAp',
            component: ApEditView,
            meta: {
              requiresAuth: true,
              prettyName: 'Edit AP',
              permissionsRequired: ['entry.view_accountspayable']
            }
          }
        ]
      },
      {
        path: 'ars',
        component: ArIndexView,
        meta: { requiresAuth: true, permissionsRequired: ['entry.view_accountsreceivable'] },
        children: [
          {
            path: '',
            name: 'ARs',
            component: ArListView,
            meta: {
              requiresAuth: true,
              prettyName: 'Accounts Receivable',
              permissionsRequired: ['entry.view_accountsreceivable']
            }
          },
          {
            path: 'new',
            name: 'NewAr',
            component: ArCreateView,
            meta: {
              requiresAuth: true,
              prettyName: 'New AR',
              permissionsRequired: ['entry.view_accountsreceivable', 'entry.add_accountsreceivable']
            }
          },
          {
            path: ':id',
            name: 'EditAr',
            component: ArEditView,
            meta: {
              requiresAuth: true,
              prettyName: 'Edit AR',
              permissionsRequired: ['entry.view_accountsreceivable']
            }
          }
        ]
      },
      {
        path: 'bps',
        component: BpIndexView,
        meta: { requiresAuth: true },
        children: [
          {
            path: '',
            name: 'BPs',
            component: BpListView,
            meta: {
              requiresAuth: true,
              prettyName: 'Bill Payments'
            }
          },
          {
            path: 'new',
            name: 'NewBp',
            component: BpCreateView,
            meta: {
              requiresAuth: true,
              prettyName: 'New Bill Payment'
            }
          },
          {
            path: ':id',
            name: 'EditBp',
            component: BpEditView,
            meta: {
              requiresAuth: true,
              prettyName: 'Edit Bill Payment'
            }
          }
        ]
      },
      {
        path: 'pps',
        component: PpIndexView,
        meta: { requiresAuth: true },
        children: [
          {
            path: '',
            name: 'PPs',
            component: PpListView,
            meta: {
              requiresAuth: true,
              prettyName: 'Deposits'
            }
          },
          {
            path: 'new',
            name: 'NewPp',
            component: PpCreateView,
            meta: {
              requiresAuth: true,
              prettyName: 'New Deposit'
            }
          },
          {
            path: ':id',
            name: 'EditPp',
            component: PpEditView,
            meta: {
              requiresAuth: true,
              prettyName: 'Edit Deposit'
            }
          }
        ]
      },
      {
        path: 'payroll',
        component: BpIndexView,
        meta: { requiresAuth: true },
        children: [
          {
            path: 'clientexport',
            name: 'PrExport',
            component: PayrollClientExport,
            meta: {
              requiresAuth: true,
              prettyName: 'Payroll Client Export'
            }
          },
          {
            path: 'status',
            name: 'PrStatus',
            component: PayrollStatus,
            meta: {
              requiresAuth: true,
              prettyName: 'Payroll Status'
            }
          },
          {
            path: 'prcheckregister',
            name: 'PrCheckRegister',
            component: PayrollCheckRegister,
            meta: {
              requiresAuth: true,
              prettyName: 'Payroll Check Register'
            }
          },
          {
            path: 'prtaxliability',
            name: 'PrTaxLiability',
            component: PayrollTaxLiability,
            meta: {
              requiresAuth: true,
              prettyName: 'Payroll Tax Liability'
            }
          },
          {
            path: 'unionexport',
            name: 'PrUnion',
            component: PayrollUnionExport,
            meta: {
              requiresAuth: true,
              prettyName: 'Payroll Union Export'
            }
          },
          {
            path: 'reports',
            name: 'PrReport',
            component: PayrollTransactionCustom,
            meta: {
              requiresAuth: true,
              prettyName: 'Payroll Detail Report'
            }
          },
          {
            path: 'ddexport',
            name: 'PrDdExport',
            component: PayrollDdExport,
            meta: {
              requiresAuth: true,
              prettyName: 'Payroll Direct Deposit'
            }
          }
        ]
      },
      {
        path: 'pettycash',
        component: PcIndexView,
        meta: { requiresAuth: true, permissionsRequired: ['entry.view_pettycash'] },
        beforeEnter: async (to, from, next) => {
          try {
            const { getCurrentPeriod } = store.getters
            if (!(getCurrentPeriod && Object.keys(getCurrentPeriod).length)) {
              await store.dispatch('fetchPeriodsWithQuery', { active: 'True' })
            }
          } catch (e) {
            console.log(e)
          } finally {
            next()
          }
        },
        children: [
          {
            path: '',
            name: 'PCs',
            component: PcListView,
            meta: {
              requiresAuth: true,
              prettyName: 'Petty Cash',
              permissionsRequired: ['entry.view_pettycash']
            }
          },
          {
            path: 'new',
            name: 'NewPc',
            component: PcCreateView,
            meta: {
              requiresAuth: true,
              prettyName: 'New PC',
              permissionsRequired: ['entry.view_pettycash', 'entry.add_pettycash']
            }
          },
          {
            path: ':id',
            name: 'EditPc',
            component: PcEditView,
            meta: {
              requiresAuth: true,
              prettyName: 'Edit PC',
              permissionsRequired: ['entry.view_pettycash']
            }
          }
        ]
      },
      {
        path: 'pos',
        component: PoIndexView,
        meta: { requiresAuth: true, permissionsRequired: ['entry.view_purchaseorder'] },
        beforeEnter: async (to, from, next) => {
          try {
            const { getCurrentPeriod } = store.getters
            if (!(getCurrentPeriod && Object.keys(getCurrentPeriod).length)) {
              await store.dispatch('fetchPeriodsWithQuery', { active: 'True' })
            }
          } catch (e) {
            console.log(e)
          } finally {
            next()
          }
        },
        children: [
          {
            path: '',
            name: 'POs',
            component: PoListView,
            meta: {
              requiresAuth: true,
              prettyName: 'Purchase Orders',
              permissionsRequired: ['entry.view_purchaseorder']
            }
          },
          {
            path: 'new',
            name: 'NewPo',
            component: PoCreateView,
            meta: {
              requiresAuth: true,
              prettyName: 'New PO',
              permissionsRequired: ['entry.view_purchaseorder', 'entry.add_purchaseorder']
            }
          },
          {
            path: ':id',
            name: 'EditPo',
            component: PoEditView,
            meta: {
              requiresAuth: true,
              prettyName: 'Edit PO',
              permissionsRequired: ['entry.view_purchaseorder']
            }
          }
        ]
      },
      {
        path: 'prs',
        component: PrIndexView,
        meta: { requiresAuth: true, permissionsRequired: ['entry.view_payrollentry'] },
        children: [
          {
            path: '',
            name: 'PRs',
            component: PrListView,
            meta: {
              requiresAuth: true,
              prettyName: 'Payroll Entries',
              permissionsRequired: ['entry.view_payrollentry']
            }
          },
          {
            path: 'new',
            name: 'NewPr',
            component: PrCreateView,
            meta: {
              requiresAuth: true,
              prettyName: 'New PR',
              permissionsRequired: ['entry.view_payrollentry', 'entry.add_payrollentry']
            }
          },
          {
            path: ':id',
            name: 'EditPr',
            component: PrEditView,
            meta: {
              requiresAuth: true,
              prettyName: 'Edit PR',
              permissionsRequired: ['entry.view_payrollentry']
            }
          }
        ]
      },
      {
        path: 'checks',
        name: 'Checks',
        component: Checks,
        meta: { requiresAuth: true, permissionsRequired: ['entry.view_payment'] }
      },
      {
        path: 'payments',
        name: 'Payments',
        component: Payments,
        meta: { requiresAuth: true, permissionsRequired: ['entry.view_payment'] }
      },
      {
        path: 'accounts',
        name: 'Accounts',
        component: AccountListView,
        meta: { requiresAuth: true, permissionsRequired: ['system.view_account'] }
      },
      {
        path: 'accountgroup',
        name: 'Account Group',
        component: AccountGroup,
        meta: { requiresAuth: true, permissionsRequired: ['system.view_accountgroup'] }
      },
      {
        path: 'vendors',
        name: 'Vendors',
        component: VendorListView,
        meta: { requiresAuth: true, permissionsRequired: ['system.view_vendor'] }
      },
      {
        path: 'sets',
        name: 'Sets',
        component: SetListView,
        meta: { requiresAuth: true, permissionsRequired: ['system.view_set'] }
      },
      {
        path: 'users',
        name: 'Users',
        component: UserView,
        meta: { requiresAuth: true, permissionsRequired: ['auth.view_user'] }
      },
      {
        path: 'roles',
        name: 'Roles',
        component: RolesListView,
        meta: { requiresAuth: true, permissionsRequired: ['system.view_roles'] }
      },
      // {
      //   path: 'addresses',
      //   name: 'Addresses',
      //   component: AddressListView,
      //   meta: { requiresAuth: true, permissionsRequired: ['view_address'] }
      // },
      {
        path: 'states',
        name: 'States',
        component: States,
        meta: { requiresAuth: true, permissionsRequired: ['system.view_state'] }
      },
      {
        path: 'countries',
        name: 'Countries',
        component: Countries,
        meta: { requiresAuth: true, permissionsRequired: ['system.view_country'] }
      },
      {
        path: 'series',
        name: 'Series',
        component: SeriesListView,
        meta: { requiresAuth: true, permissionsRequired: ['system.view_series'] }
      },
      {
        path: 'locations',
        name: 'Locations',
        component: LocationListView,
        meta: { requiresAuth: true, permissionsRequired: ['system.view_location'] }
      },
      {
        path: 'insurancecodes',
        name: 'Insurances',
        component: InsuranceListView,
        meta: {
          requiresAuth: true,
          prettyName: 'Insurance Codes',
          permissionsRequired: ['system.view_insurance']
        }
      },
      {
        path: 'freefields',
        name: 'Freefields',
        component: Freefields,
        meta: {
          requiresAuth: true,
          prettyName: 'Free Fields',
          permissionsRequired: ['system.view_freefield']
        }
      },
      {
        path: 'taxcodes',
        name: 'Taxcodes',
        component: TaxcodeListView,
        meta: {
          requiresAuth: true,
          prettyName: 'Tax Codes',
          permissionsRequired: ['system.view_countrytaxcode']
        }
      },
      {
        path: 'budgets',
        name: 'Budgets',
        component: BudgetListView,
        meta: { requiresAuth: true, permissionsRequired: ['system.view_budget'] }
      },
      {
        path: 'budgetImport',
        name: 'BudgetImport',
        component: BudgetImportView,
        meta: { requiresAuth: true, permissionsRequired: ['system.view_budget'] }
      },
      {
        path: 'assets',
        name: 'Assets',
        component: AssetListView,
        meta: { requiresAuth: true, permissionsRequired: ['system.view_asset'] }
      },
      {
        path: 'banks',
        name: 'Banks',
        component: BankListView,
        meta: { requiresAuth: true, permissionsRequired: ['system.view_bank'] }
      },
      {
        path: 'companies',
        name: 'Companies',
        component: CompanyListView,
        meta: { requiresAuth: true, permissionsRequired: ['system.view_company'] }
      },
      {
        path: 'currencies',
        name: 'Currencies',
        component: CurrencyListView,
        meta: { requiresAuth: true, permissionsRequired: ['system.view_currency'] }
      },
      {
        path: 'productions',
        name: 'Productions',
        component: ProductionListView,
        meta: { requiresAuth: true, permissionsRequired: ['system.view_production'] }
      },
      {
        path: 'salesreps',
        name: 'Salesreps',
        component: SalesrepListView,
        meta: { requiresAuth: true, permissionsRequired: ['system.view_salesrep'] }
      },
      {
        path: 'customers',
        name: 'Customers',
        component: CustomerListView,
        meta: { requiresAuth: true, permissionsRequired: ['system.view_customer'] }
      },
      {
        path: 'billabletypes',
        name: 'BillableTypes',
        component: BillabletypeListView,
        meta: { requiresAuth: true, permissionsRequired: ['system.view_billabletype'] }
      },
      {
        path: 'billableitems',
        name: 'BillableItems',
        component: BillableitemListView,
        meta: { requiresAuth: true, permissionsRequired: ['system.view_billableitem'] }
      },
      {
        path: 'markups',
        name: 'Markups',
        component: MarkupListView,
        meta: { requiresAuth: true, permissionsRequired: ['system.view_markup'] }
      },
      {
        path: 'programs',
        component: ProgramsIndexView,
        meta: { requiresAuth: true },
        children: [
          {
            path: 'posting',
            name: 'TransactionPosting',
            component: TransactionPostingView,
            meta: {
              requiresAuth: true,
              prettyName: 'Transaction Posting',
              permissionsRequired: ['auth.post_transactions']
            }
          },
          {
            path: 'checks',
            name: 'CheckProcessing',
            component: CheckProcessingView,
            meta: {
              requiresAuth: true,
              prettyName: 'Check Processing',
              permissionsRequired: ['entry.view_payment']
            }
          },
          {
            path: 'payments',
            name: 'PaymentProcessing',
            component: PaymentProcessing,
            meta: {
              requiresAuth: true,
              prettyName: 'Payment Processing',
              permissionsRequired: ['entry.view_payment']
            }
          },
          {
            path: 'vendorimport',
            name: 'VendorImport',
            component: VendorImport,
            meta: { requiresAuth: true }
          },
          {
            path: 'positivepay',
            name: 'PositivePay',
            component: PositivePay,
            meta: {
              requiresAuth: true,
              prettyName: 'Positive Pay',
              permissionsRequired: ['entry.pospay_payment']
            }
          },
          // {
          //   path: 'nachaexport',
          //   name: 'NachaExport',
          //   component: NachaExport,
          //   meta: {
          //     requiresAuth: true,
          //     prettyName: 'ACH Export',
          //     permissionsRequired: ['entry.add_papercheck', 'entry.change_papercheck', 'entry.delete_papercheck']
          //   }
          // },
          // {
          //   path: 'costreporter',
          //   name: 'CostReporter',
          //   component: CostReporterView,
          //   meta: {
          //     requiresAuth: true,
          //     prettyName: 'Cost Reporter',
          //     permissionsRequired: ['system.add_budgetline', 'system.change_budgetline', 'system.delete_budgetline']
          //   }
          // },
          {
            path: 'costreporter',
            name: 'CostReporter',
            component: CostReporterBetaView,
            meta: {
              requiresAuth: true,
              prettyName: 'Cost Reporter',
              permissionsRequired: ['auth.view_cost_report']
            }
          },
          {
            path: 'periodmanager',
            name: 'PeriodManager',
            component: PeriodManagerView,
            meta: {
              requiresAuth: true,
              prettyName: 'Period Manager',
              permissionsRequired: ['entry.view_period']
            }
          },
          {
            path: 'bankrecs',
            component: BankRecIndexView,
            meta: { requiresAuth: true, permissionsRequired: ['programs.view_bankrecon'] },
            children: [
              {
                path: '',
                name: 'BankRecs',
                component: BankRecListView,
                meta: {
                  requiresAuth: true,
                  prettyName: 'Bank Reconciliations',
                  permissionsRequired: ['programs.view_bankrecon']
                }
              },
              {
                path: 'new',
                name: 'NewBankRec',
                component: BankRecCreateView,
                meta: {
                  requiresAuth: true,
                  prettyName: 'New Bank Reconciliation',
                  permissionsRequired: ['programs.view_bankrecon', 'programs.post_bankrec']
                }
              },
              {
                path: ':id',
                name: 'ViewBankRec',
                component: BankRecReadView,
                meta: {
                  requiresAuth: true,
                  prettyName: 'View Bank Reconciliation',
                  permissionsRequired: ['programs.view_bankrecon']
                }
              }
            ]
          },
          {
            path: 'signaturecapture',
            name: 'SignatureCapture',
            component: SignatureCapture,
            meta: {
              requiresAuth: true,
              prettyName: 'Signature Capture'
            }
          }
        ]
      },
      {
        path: 'reports',
        component: ProgramsIndexView,
        meta: { requiresAuth: true },
        children: [
          {
            path: 'trialbalance',
            name: 'TrialBalance',
            component: TrialBalanceCustom,
            meta: {
              requiresAuth: true,
              prettyName: 'Trial Balance',
              permissionsRequired: ['auth.view_trail_balance']
            }
          },
          {
            path: 'glreport',
            name: 'GlReport',
            component: GlReportCustom,
            meta: {
              requiresAuth: true,
              prettyName: 'GL Bible Report',
              permissionsRequired: ['auth.view_gl_bible_report']
            }
          },
          {
            path: 'openitemsbyaccount',
            name: 'OpenItemsByAccount',
            component: OpenItemsByAccountReport,
            meta: {
              requiresAuth: true,
              prettyName: 'Open Items By Account Report',
              permissionsRequired: ['auth.view_gl_bible_report']
            }
          },
          {
            path: 'openitemsbyvendor',
            name: 'openitemsbyvendor',
            component: OpenItemsByVendorReport,
            meta: {
              requiresAuth: true,
              prettyName: 'Open Items By Vendor Report',
              permissionsRequired: ['auth.view_vendor_history_report']
            }
          },
          {
            path: 'employeereport',
            name: 'Employee Earnings Report',
            component: EmployeeEarningsReport,
            meta: {
              requiresAuth: true,
              prettyName: 'Employee Earnings Report',
              permissionsRequired: ['propay.view_employee_earning_report']
            }
          },
          {
            path: 'poreport',
            name: 'PoReport',
            component: PoReportCustom,
            meta: {
              requiresAuth: true,
              prettyName: 'PO Reports',
              permissionsRequired: ['auth.view_purchase_orders_report']
            }
          },
          {
            path: 'poreport1',
            name: 'PoReport',
            component: PoReportCustom1,
            meta: {
              requiresAuth: true,
              prettyName: 'PO Reports',
              permissionsRequired: ['auth.view_purchase_orders_report']
            }
          },
          {
            path: 'apagingreport',
            name: 'APAgingReport',
            component: APAgingReport,
            meta: {
              requiresAuth: true,
              prettyName: 'Accounts Payable Aging Report',
              permissionsRequired: ['auth.view_ap_aging_report']
            }
          },
          {
            path: 'bankrecreport',
            name: 'BankRecReport',
            component: BankRecReportCustom,
            meta: {
              requiresAuth: true,
              prettyName: 'Bank Reconciliation Report',
              permissionsRequired: ['programs.view_bankrecon', 'programs.post_bankrec']
            }
          },
          {
            path: 'checkregister',
            name: 'CheckRegister',
            component: CheckRegister,
            meta: {
              requiresAuth: true,
              prettyName: 'Check Register',
              permissionsRequired: ['auth.view_check_register']
            }
          },
          {
            path: 'paymentregister',
            name: 'CheckRegister',
            component: CheckRegister,
            meta: {
              requiresAuth: true,
              prettyName: 'Payment Register',
              permissionsRequired: ['auth.view_check_register']
            }
          },
          {
            path: 'vendorreport',
            name: 'VendorReport',
            component: VendorReportCustom,
            meta: {
              requiresAuth: true,
              prettyName: 'Vendor Report',
              permissionsRequired: ['auth.view_vendor_history_report']
            }
          },
          {
            path: 'vendorlist',
            name: 'VendorListCustom',
            component: VendorListCustom,
            meta: {
              requiresAuth: true,
              prettyName: 'Vendor List Report',
              permissionsRequired: ['auth.view_vendor_list_report']
            }
          },
          {
            path: 'accountlist',
            name: 'AccountListCustom',
            component: AccountListCustom,
            meta: {
              requiresAuth: true,
              prettyName: 'Account List',
              permissionsRequired: ['auth.view_chart_of_accounts_report']
            }
          },
          {
            path: 'assetreport',
            name: 'AssetReport',
            component: AssetReportCustom,
            meta: {
              requiresAuth: true,
              prettyName: 'Asset Report',
              permissionsRequired: ['auth.view_asset_reporting_report']
            }
          },
          {
            path: 'taxreport',
            name: 'TaxReport',
            component: TaxReportCustom,
            meta: {
              requiresAuth: true,
              prettyName: '1099 Report',
              permissionsRequired: ['auth.view_1099_tax_reporting']
            }
          },
          {
            path: 'taxreport2020',
            name: 'TaxReport2020',
            component: TaxReportCustom2020,
            meta: {
              requiresAuth: true,
              prettyName: '1099 2020 Report',
              permissionsRequired: ['auth.view_1099_tax_reporting']
            }
          },
          {
            path: 'taxreport2021',
            name: 'TaxReport2021',
            component: TaxReportCustom2021,
            meta: {
              requiresAuth: true,
              prettyName: '1099 2021 Report',
              permissionsRequired: ['auth.view_1099_tax_reporting']
            }
          },
          {
            path: 'taxreport2022',
            name: 'TaxReport2022',
            component: TaxReportCustom2022,
            meta: {
              requiresAuth: true,
              prettyName: '1099 2022 Report',
              permissionsRequired: ['auth.view_1099_tax_reporting']
            }
          },
          {
            path: 'taxreport2023',
            name: 'TaxReport2023',
            component: TaxReportCustom2023,
            meta: {
              requiresAuth: true,
              prettyName: '1099 2023 Report',
              permissionsRequired: ['auth.view_1099_tax_reporting']
            }
          },
          {
            path: 'taxreport2024',
            name: 'TaxReport2024',
            component: TaxReportCustom2024,
            meta: {
              requiresAuth: true,
              prettyName: '1099 2024 Report',
              permissionsRequired: ['auth.view_1099_tax_reporting']
            }
          },
          {
            path: 'taxreport2025',
            name: 'TaxReport2025',
            component: TaxReportCustom2025,
            meta: {
              requiresAuth: true,
              prettyName: '1099 2025 Report',
              permissionsRequired: ['auth.view_1099_tax_reporting']
            }
          }
        ]
      },
      {
        path: 'searchresults',
        name: 'SearchResults',
        component: SearchResults,
        meta: { requiresAuth: true }
      },
      {
        path: '/home',
        name: 'Home',
        component: HomeView,
        meta: { requiresAuth: true }
      },
      {
        path: '/departments',
        name: 'Departments',
        component: DepartmentsListView,
        meta: { requiresAuth: true, permissionsRequired: ['system.view_department'] }
      }
    ]
  }
]

const router = new Router({ mode: 'history', routes })

/**
 * Router guard that contains pre-navigation logic
 */
router.beforeEach(async (to, from, next) => {
  if (!to.meta.requiresAuth) {
    return next()
  }
  try {
    await store.dispatch('verifyAuth')                        // Verify authentication status/set auth info from localStorage in store.
    if (!store.getters.getJasperHost) {
      await store.dispatch('fetchJasperHost')
    }
    if (!store.getters.getSigmaQueryUrl) {
      await store.dispatch('fetchSigmaQueryUrl')
    }
    if (store.getters.getToken) {                             // Get the token from the active instance. If it exists...
      await store.dispatch('checkTokenExpiration')            // - check if it's expired
      const permissions = await store.dispatch('fetchUserPermissions')         // Fetch permissions
      const checkPermission = to.name && to.name === 'Proscan' ? 'checkIfUserHasAnyOfThePermissions' : 'checkIfUserHasRequiredPermissions'
      if (permissions && to.meta.permissionsRequired && !store.getters[checkPermission](to.meta.permissionsRequired)) {
        Vue.prototype.$globalNotification = Vue.prototype.$notify
        const message = 'You do not have permission to access this resource. Please contact an administrator'
        Vue.prototype.$globalNotification.error({ title: 'Unauthorized', message, duration: 10000 })
        setTimeout(() => (Vue.prototype.$globalNotification = null), 10000)
        next({ name: 'Home' })
      }
      if (store.getters.getReauthStatus && from.path !== '/') {                     // - check if reauthentication is needed. If so...
        await store.dispatch('setPostAuthorizationRoute', to.name)                  // - set the route the user was going to in state
        next(false)                                                             // - and prevent navigation
      } else if (store.getters.getReauthStatus && from.path === '/') {
        await Promise.all([store.dispatch('setPostAuthorizationRoute', to.name), store.dispatch('logout')])
        store.dispatch('setLogoutNotifMsg', 'Session expired - please sign in again.')
        return next({name: 'Login'})
      } else {                                                // - If not...
        store.dispatch('trackNavigation', true)               // - set navigation state, used to show spinner between route navigation
        next()                                                // - and proceed to target route normally
      }
    } else {                                                  // If the token doesn't exist
      await store.dispatch('trackNavigation', true)           // - set navigation state, used to show spinner between route navigation
      await store.dispatch('setPostAuthorizationRoute', store.getters.getPostAuthorizationRoute || to.name)          // - set the route to which to continue to navigate to after login
      await store.dispatch('logout')                          // - log the user out
      if (from.name) {
        store.dispatch('setLogoutNotifMsg', 'Session expired - please sign in again.')
      }
      return next({name: 'Login'})                            // - and return the user to the login view
    }
  } catch (e) {
    console.log(e)
    await store.dispatch('logout')
    next({name: 'Login'})
  }
  if (Vue.mixpanel) {
    let user = store.getters.getUser
    let instance = store.getters.getActiveInstance
    if (instance && instance.url) {
      Vue.mixpanel.track(`Page View`, {
        path: to.path,
        distinct_id: user.username,
        instance: instance.url,
        $email: user.email
      })
    }
  }
})

router.afterEach((to, from) => {
  store.dispatch('trackNavigation', false)                        // Set navigation state, used to show spinner between route navigation
  store.dispatch('confirmRouteLeave', false)
  store.dispatch('setDestinationRoute')
  let title = document.getElementById('page-title')               // Dynamically change page title based on route
  let defaultTitle = 'ProBooks'
  if (!title) {
    const titleEls = document.getElementsByTagName('title')
    if (titleEls && titleEls.length) title = titleEls[0]
  }
  if (title && title.text) {
    if (to.meta && to.meta.prettyName) {
      title.text = `${to.meta.prettyName} | ${defaultTitle}`
    } else if (to.name) {
      title.text = `${to.name} | ${defaultTitle}`
    } else {
      title.text = defaultTitle
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js